var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleAirlines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99971 22.0006L13.8997 7.00059H21.9997L19.2997 22.0006H3.99971ZM15.2497 16.3756C15.8797 16.3756 16.4122 16.149 16.8472 15.6959C17.2822 15.2428 17.4997 14.6881 17.4997 14.0318C17.4997 13.3756 17.2822 12.8209 16.8472 12.3678C16.4122 11.9146 15.8797 11.6881 15.2497 11.6881C14.6197 11.6881 14.0872 11.9146 13.6522 12.3678C13.2172 12.8209 12.9997 13.3756 12.9997 14.0318C12.9997 14.6881 13.2172 15.2428 13.6522 15.6959C14.0872 16.149 14.6197 16.3756 15.2497 16.3756Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.103 17.001H1.99951L11.8995 2.00098H19.9995L19.2794 6.00176H17.2472L17.6074 4.00098H12.9758L5.71584 15.001H7.423L6.103 17.001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleAirlines);
export default __webpack_public_path__ + "static/media/multiple_airlines.5fbade634c1526f59c08c725c924849b.svg";
export { ForwardRef as ReactComponent };